import { render, staticRenderFns } from "./register-payment.vue?vue&type=template&id=043af5fe&"
import script from "./register-payment.vue?vue&type=script&lang=js&"
export * from "./register-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports